/*
Copyright © 2021 EPAM Systems, Inc. All Rights Reserved.
All information contained herein is, and remains the property of EPAM Systems, Inc.
and/or its suppliers and is protected by international intellectual property law.
Dissemination of this information or reproduction of this material is strictly
forbidden, unless prior written permission is obtained from EPAM Systems, Inc
*/
import React, { useEffect, useState } from 'react';
import { belarusianPhone, startWithBelarusianPrefix } from '../../utils';
import { FormMaskedInput } from './FormMaskedInput';

const BY = 'BY';
const OTHER = 'other';

export const PhoneInput = ({
    id,
    value = '+375',
    onChange,
    onBlur,
    error,
    required,
    disabled,
    readOnly,
}) => {
    const [ phoneType, setPhoneType ] = useState(OTHER);

    useEffect(() => {
        if (!value) {
            setPhoneType(BY);
        }
    }, []);

    // const [ val, setVal ] = useState(value);

    // const getVal = useCallback(() => {
    //     const cn = clearPhone(value);
    //     console.log('val', {
    //         value,
    //         cn,
    //     });
    //     return cn === '' ? '+375' : value;
    // }, [value]);

    useEffect(() => {
        if (belarusianPhone.test(value) && phoneType === OTHER) {
            setPhoneType(BY);
        } else if (!startWithBelarusianPrefix.test(value) && phoneType === BY) {
            setPhoneType(OTHER);
        }
        // if (value?.trim?.() === '') {
        //     setVal('+375');
        // }
    }, [value]);

    // console.log('getVal', getVal(), value);

    const mask = [
        {
            mask: '{+}000 (00) 000-00-00',
            startsWith: '375',
            country: 'Belarus',
            lazy: false,
        },
        {
            mask: '{+}0 00[0] 00[0]-00-00',
            startsWith: '7',
            lazy: false,
            country: 'Russia',
        },
        {
            mask: '{+}00000000000[0][0][0]',
            startsWith: '',
            lazy: true,
            country: 'other',
        },
    ];

    const dispatch = (appended, dynamicMasked) => {
        const number = (dynamicMasked.value + appended).replace(/\D/g, '');
        return dynamicMasked.compiledMasks.find(m => number.indexOf(m.startsWith) === 0);
    };

    return (
        <>
            <FormMaskedInput
                id={`${id}_phone`}
                value={value || '+375'}
                mask={mask}
                dispatch={dispatch}
                unmask={true}
                onChange={onChange}
                onBlur={onBlur}
                error={error}
                required={required}
                readOnly={readOnly}
                disabled={disabled}
            />
        </>
    );
};
